import { useWatch } from 'react-hook-form';

import { useZodFormContext } from '../../../../hooks/useZodForm.ts';
import { RecommendCompsFormSchema } from '../../types.ts';
import { filterHasValue } from '../../utils/filterHasValue.ts';
import { EMPTY_RANGE_FILTER, FilterSection } from './FilterSection.tsx';
import { ValueButtonGroup } from './ValueButtonGroup.tsx';

type MinMaxButtonFilterFieldName =
  | 'bedrooms'
  | 'fullBaths'
  | 'halfBaths'
  | 'garageSpaces'
  | 'quality'
  | 'condition';

export const MinMaxButtonFilter = ({
  label,
  fieldName,
  options,
  hasPlus,
  formatLabel,
}: {
  label: string;
  fieldName: MinMaxButtonFilterFieldName;
  options: number[];
  hasPlus?: boolean;
  formatLabel?: (option: number, index: number) => string;
}) => {
  const { control, setValue } = useZodFormContext<RecommendCompsFormSchema>();
  const filterValue = useWatch({ control, name: `search.filters.${fieldName}` });
  const filterMin = useWatch({ control, name: `search.filters.${fieldName}.min` });
  const filterMax = useWatch({ control, name: `search.filters.${fieldName}.max` });

  const clearFilter = () => {
    setValue(`search.filters.${fieldName}`, { ...EMPTY_RANGE_FILTER });
    setValue(`search.matchCriteria.${fieldName}`, 'min_max_range');
  };

  return (
    <FilterSection
      label={label}
      showClear={filterHasValue(filterValue)}
      onClear={clearFilter}
    >
      <ValueButtonGroup
        options={options}
        hasPlus={hasPlus}
        formatLabel={formatLabel}
        min={typeof filterMin === 'number' ? filterMin : undefined}
        max={typeof filterMax === 'number' ? filterMax : undefined}
        onRangeChange={(nextMin, nextMax) => {
          setValue(`search.matchCriteria.${fieldName}`, 'min_max_range');
          setValue(`search.filters.${fieldName}`, {
            ...EMPTY_RANGE_FILTER,
            min: nextMin ?? '',
            max: nextMax ?? '',
          });
        }}
      />
    </FilterSection>
  );
};
